module.exports = __webpack_public_path__ + "media/images/icons/social/tiktok-a6fb3e3a3a4416e79958f298e5404753.svg";